export default "__VITE_ASSET__Dj62x6_$__"